/* tslint:disable */
/* eslint-disable */
/**
 * BS BFF(ダイナミックパッケージ/DP補助金申請) API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponseMenuBasicInfoCategoryInfomation
 */
export interface JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponseMenuBasicInfoCategoryInfomation {
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponseMenuBasicInfoCategoryInfomation
     */
    catSmlClassNm?: string;
}

export function JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponseMenuBasicInfoCategoryInfomationFromJSON(json: any): JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponseMenuBasicInfoCategoryInfomation {
    return JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponseMenuBasicInfoCategoryInfomationFromJSONTyped(json, false);
}

export function JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponseMenuBasicInfoCategoryInfomationFromJSONTyped(json: any, ignoreDiscriminator: boolean): JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponseMenuBasicInfoCategoryInfomation {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'catSmlClassNm': !exists(json, 'catSmlClassNm') ? undefined : json['catSmlClassNm'],
    };
}

export function JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponseMenuBasicInfoCategoryInfomationToJSON(value?: JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponseMenuBasicInfoCategoryInfomation | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'catSmlClassNm': value.catSmlClassNm,
    };
}

